import { render } from "./index.vue?vue&type=template&id=5d846633&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5d846633&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=5d846633&scoped=true&lang=css"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d846633"]])

export default __exports__